import "./plugins";

export default {};
